import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "canvas" ]
  static classes = [ "show", "hide", "state" ]

  initialize() {
    this.activeButtons = new Set()
  }

  show(e) {
    this.canvasTarget.classList.toggle(this.hideClass)
    this.canvasTarget.classList.toggle(this.showClass)

    const { currentTarget: button } = e
    if (button.classList.contains(this.stateClass)) {
      e.preventDefault()
    }

    button.classList.toggle(this.stateClass)
    this.activeButtons.add(button)
  }

  hide() {
    this.canvasTarget.classList.add(this.hideClass)
    this.canvasTarget.classList.remove(this.showClass)

    this.activeButtons.forEach(button => { button.classList.remove(this.stateClass) })
  }
}
